import {useMutation} from "@tanstack/react-query";

import {addMaterialDescriptionMutationOptions} from "./add-material-description.mutation-options";

export function useAddMaterialDescription(id: string) {
  return useMutation(addMaterialDescriptionMutationOptions(id));
}
